import { useSelector } from 'react-redux';
import { CAPABILITY_KEYS } from '../constants/capabilities';
import { hasLoadedCapabilities } from '../utils/capabilityUtils';
import { useCapability } from './useCapability';

/**
 * Billing access is pure capability: `billing-invoices.view` alone decides,
 * regardless of role. Fails closed: everything is false until capabilities load,
 * and a load failure resolves as denied.
 */
export const useBillingAccess = () => {
  const capability = useCapability(CAPABILITY_KEYS.BILLING_INVOICES);
  const loadFailed = Boolean(useSelector((state) => state.orgSettings.capabilitiesLoadFailed));
  const capabilitiesLoaded = Boolean(hasLoadedCapabilities(capability.capabilities));

  return {
    canViewBilling: capabilitiesLoaded && capability.visible,
    isResolved: capabilitiesLoaded || loadFailed,
    loadFailed,
    capabilitiesLoaded,
  };
};
